<template>
    <div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap"
                 :size="GCONFIG.styleElFormSize">
            <el-form-item label="商品名称">
                <el-input v-model="formInline.searchName" placeholder="商品名称"></el-input>
            </el-form-item>
            <el-form-item label="会员等级">
                <el-select :popper-append-to-body="true" clearable  v-model="formInline.vipLevel">
                        <el-option
                                v-for="item in priceType"
                                :key="item.value"
                                :label="item.name"
                                :value="item.value">
                        </el-option>
                    </el-select>
            </el-form-item>

            <el-form-item>
                <el-button type="primary" @click="getList">查询</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="proList" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading">
            <!--  <el-table-column type="selection" width="55"></el-table-column>-->
            <el-table-column type="index" label="序号" width="60"></el-table-column>
            <el-table-column prop="PRO_ID" label="商品ID"></el-table-column>
            <el-table-column prop="PRO_NAME" label="产品名称"></el-table-column>
            <el-table-column prop="PRO_TYPE" label="商品类型">
                <template slot-scope="scope">
                    {{scope.row.PRO_TYPE==1?'促销':(scope.row.PRO_TYPE==4?'单品':'未知')}}
                </template>
            </el-table-column>
            <el-table-column prop="PRICE_TYPE_NAME" label="会员级别"></el-table-column>
            <el-table-column prop="PRICE" label="会员价格" width="160">
                <template slot-scope="scope">
                    <el-input-number v-model="scope.row.PRICE"></el-input-number>
                </template>
            </el-table-column>
            <el-table-column prop="PRO_PRICE" label="原价"></el-table-column>
            <el-table-column label="状态">
                <template  slot-scope="scope">
                    {{scope.row.STATUS}}
                </template>
            </el-table-column>
            <el-table-column prop="PRICE_ID" label="标识Id">
            </el-table-column>
            <el-table-column label="操作" fixed="right" width="200">
                <template slot-scope="scope">
                    <el-button-group>
                        <el-button type="primary"  size="mini" @click="handleEditPrice(scope.row)">保存</el-button>
                        <el-button type="danger" :disabled="scope.row.PRICE_ID==null" size="mini" @click="handleDel(scope.row)">删除</el-button>
                    </el-button-group>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    //导入 HTTP请求方法
    import {saveProductPrice, getProductPriceList,delPrice} from '../../api/api'
    //定义组件
    export default{
        data(){
            return {
                proList: [],
                loading: true,
                priceType: [{value: 31, name: '39会员'}, {value: 32, name: '99会员'}, {value: 33, name: '199会员'}],
                formInline: {
                    currentPage: parseInt(this.$route.params.id) || 1,
                    recordsTotal: 0,
                    vipLevel:0,
                    pageSize: 10,
                },
                form: {
                    priceId: '',
                    proId: '',
                    price: '',
                    priceType: '',
                    proType: ''
                }
            }
        },
        components: {},
        computed: {},
        //挂载时候执行
        mounted(){
            //初始化首页数据
            this.getList();
        },
        methods: {
            //定义查询方法
            getList(){
                this.loading = true;
                getProductPriceList(this.formInline).then((res) => {
                    this.loading = false;
                    console.log(res);
                    if (res.status == 200) {
                        this.proList = res.data.value;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            handleEditPrice(row){
                this.form = {
                    priceId: row.PRICE_ID,
                    proId: row.PRO_ID,
                    price: row.PRICE,
                    priceType: row.PRICE_TYPE,
                    proType: row.PRO_TYPE
                }
                if(this.form.price==null||this.form.priceType==null){
                    this.$message({
                        showClose: true,
                        message: '价格及会员级别必填',
                        type: 'error'
                    });
                    return;
                }
                this.loading = true;
                saveProductPrice(this.form).then((res) => {
                    this.loading = false;
                    if (res.data.status == 200) {
                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                        this.getList();
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },

            handleChangePrice(){
                this.modifyPriceMode = this.currentPriceMode;
                this.showPriceChangeDialog = true;
            },
            handleDel(row){
                if (confirm("删除不可撤销，确认删除吗？")) {
                    this.loading = true;
                    delPrice({priceId: row.PRICE_ID,}).then((res) => {
                        this.loading = false;
                        console.log(res);
                        if (res.status == 200) {
                            this.getList();
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    })
                }
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getList();
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getList();
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/views/sales/productPrice.vue